import React from 'react'
import { Grid, Chip } from '@material-ui/core'
import VisibilityIcon from '@material-ui/icons/Visibility'
import Moment from 'react-moment'
import styles from './fmcsa.module.scss'
import strings from 'strings'
import Loader from "../../../../shared/Loader"
import TableComponent from 'components/shared/TableComponent'

const ExtensiveSearchList = ({ searches, loading, onViewDetails, detailsLoading }) => {
    if (loading) {
        return (
            <div className={styles.extensiveSearchListContainer}>
                <h6>{strings.EXTENSIVE_FMCSA_SEARCHES}</h6>
                <Loader />
            </div>
        )
    }

    if (!searches || searches.length === 0) {
        return null
    }

    const getStatusColor = (status) => {
        switch (status?.toUpperCase()) {
            case 'COMPLETED':
            case 'SUCCESS':
                return 'primary'
            case 'PENDING':
            case 'IN_PROGRESS':
                return 'default'
            case 'FAILED':
            case 'ERROR':
                return 'secondary'
            default:
                return 'default'
        }
    }

    const getStatusLabel = (status) => {
        switch (status?.toUpperCase()) {
            case 'COMPLETED':
                return 'Completed'
            case 'SUCCESS':
                return 'Success'
            case 'PENDING':
                return 'Pending'
            case 'IN_PROGRESS':
                return 'In Progress'
            case 'FAILED':
                return 'Failed'
            case 'ERROR':
                return 'Error'
            default:
                return status || 'Unknown'
        }
    }

    const columns = [
        {
            dataField: 'dotNumber',
            text: 'DOT Number',
            headerStyle: { width: '150px' },
            formatter: (cell) => cell || '-'
        },
        {
            dataField: 'status',
            text: 'Status',
            headerStyle: { width: '120px' },
            formatter: (cell) => (
                <Chip
                    label={getStatusLabel(cell)}
                    color={getStatusColor(cell)}
                    size="small"
                    variant="outlined"
                />
            )
        },
        {
            dataField: 'createdAt',
            text: 'Date',
            headerStyle: { width: '180px' },
            formatter: (cell) => cell ? <Moment format="MMM DD, YYYY HH:mm">{cell}</Moment> : '-'
        },
        {
            dataField: 'action',
            text: 'Action',
            headerStyle: { width: '100px' },
            formatter: (cell, row) => {
                const isCompleted = row.status?.toUpperCase() === 'COMPLETED' || row.status?.toUpperCase() === 'SUCCESS'
                return (
                    <VisibilityIcon
                        color={isCompleted ? 'primary' : 'disabled'}
                        style={{ cursor: isCompleted ? 'pointer' : 'not-allowed' }}
                        onClick={() => {
                            if (isCompleted && !detailsLoading) {
                                onViewDetails(row.uuid)
                            }
                        }}
                        titleAccess={isCompleted ? 'View Details' : 'Search not completed'}
                    />
                )
            }
        }
    ]

    return (
        <div className={styles.extensiveSearchListContainer}>
            <TableComponent
                title={strings.EXTENSIVE_FMCSA_SEARCHES}
                keyField='uuid'
                columns={columns}
                data={searches}
                showPagination={false}
                className={styles.extensiveSearchTable}
            />
        </div>
    )
}

export default ExtensiveSearchList